import { useState } from "react";

export function LazyImg({ src, alt = "", className = "", wrapClass = "", eager = false, ...rest }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <span className={`relative block w-full h-full ${wrapClass}`}>
      {!loaded && <span className="absolute inset-0 bg-slate-200 animate-pulse rounded-[inherit]" data-testid="media-skeleton" />}
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async" onLoad={() => setLoaded(true)} onError={() => setLoaded(true)}
        className={`${className} transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`} {...rest} />
    </span>
  );
}

export function LazyVideo({ src, className = "", ...rest }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <span className="relative block w-full h-full">
      {!loaded && <span className="absolute inset-0 bg-slate-200 animate-pulse" data-testid="media-skeleton" />}
      <video src={src} preload="metadata" onLoadedData={() => setLoaded(true)} onError={() => setLoaded(true)} className={className} {...rest} />
    </span>
  );
}
